export default "__VITE_ASSET__d54acfd4__"